import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { ApplicationState } from 'app/types-store';
import { compile, compileEach } from 'app/infrastructure/js';
import { SchemaBuilder } from 'app/infrastructure/ui/builder';
import { getComponentValues } from 'app/infrastructure/ui/renderer/resolvers';
import { log } from 'app/infrastructure/log';
import { createContext } from 'app/area/case/selectors/template-url/data-context';
import { isValidUrl } from 'app/infrastructure/validation/url';

/**
 * Formats a template string with placeholders pointing to specific domain id's as well as 
 * placeholders resolved from a value context object of type `TemplateUrlDataContext`.
 * 
 * @example
 * 
 *  resolve argument `d` from domain 106 (Location):
 * 
 *   "https://${server}/file?arg=${userInfo.language.description}&d=${106}"
 * 
 * 
 * @param caseState 
 * @param uiEngineProps 
 * @param appState 
 */
export const domainTemplateUrl = (
  caseState: CaseState, 
  uiEngineProps: ConnectedComponentProps, 
  appState: ApplicationState) => { 

  const encoder = (s:string) => encodeURI(s);
  const context = createContext(appState, uiEngineProps);
  const {templateUrl} = uiEngineProps.componentDescriptor.properties;
  const urlFromContext = templateUrl && compile(templateUrl as string, context, encoder);

  if(!urlFromContext ){
    return undefined;
  }
  
  const url = compileEach(urlFromContext, (identifier:string) => {

    if(!identifier){
      return '';     
    }
  
    try{
      const domainIdOrDescriptor = JSON.parse(identifier);

      if(Number.isFinite(domainIdOrDescriptor)){
        const schema = SchemaBuilder.create(caseState.renderMode, caseState.uiDefinition);
        const componentDescriptor = schema.getById(domainIdOrDescriptor);
        
        // Basic domain value support
        const valueObject = getComponentValues(caseState, {
            ...uiEngineProps,
            componentDescriptor
          }
        );
        const hasValue = valueObject && valueObject.value !== undefined;
        return hasValue ? encodeURI(valueObject.value) : '';
      }
    }catch(err){
      log(err);
    }
    
    return '${' + identifier + '}';

  });
  
  if( !isValidUrl(url as string) ){ /*?url*/
    return undefined;
  }

  return {url};
};
